module.exports = __webpack_public_path__ + "img/4.ee34a5aa.png";